import { SignInCallback } from '@amzn/event-engine-js-utils';
import SpinnerWithLabel from 'components/SpinnerWithLabel';
import useNotification from 'hooks/use-notification';
import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { i18nStrings } from 'utils/constants';

import { routes } from '../../constants';

const SignInCallbackContainer = () => {
    const history = useHistory();
    const { showNotification } = useNotification();
    const handleSignInFailure = useCallback(() => {
        showNotification(i18nStrings.signIn.callback.signInFailure, {
            type: 'error',
        });
        history.replace(routes.landingPage);
    }, []);

    return (
        <SignInCallback onSignInFailure={handleSignInFailure}>
            <SpinnerWithLabel>
                {i18nStrings.signIn.callback.signingIn}
            </SpinnerWithLabel>
        </SignInCallback>
    );
};

export default SignInCallbackContainer;
